// @ts-nocheck
import axios from '../../../services/api';
import { Localization, LocalizationEntity } from '../shared/models/localization';

const LocalizationHelper = {
  async getTranslationForNode(key: string): Promise<LocalizationEntity[]> {
    try {
      const response = await axios.get(
        '/umbraco/Api/Translations/GetTranslationForNodes?nodeKey=' + key
      );
      if (response.status === 200 && response.data.Code === 1) {
        return response.data.data;
      }
      return [];
    } catch {
      return [];
    }
  },

  getLocaleEntityValue(
    localization: Localization,
    localizationKey: string,
    defaultValue?: string
  ): string {
    if (!localization) return defaultValue;
    const value = localization.find((item) => item.key === localizationKey)?.value;
    return value ?? defaultValue;
  },

  getLocaleReplace(
    localization: Localization,
    localizationKey: string,
    valueToBeReplaced: string
  ): string {
    return (
      localization
        .find((item) => item.key === localizationKey)
        ?.value.replace(/\{{2}.*?\}{2}/, valueToBeReplaced) ?? localizationKey
    );
  },
};

export default LocalizationHelper;
